if (!customElements.get("download-template")) {
  customElements.define(
    "download-template",
    class DownloadTemplate extends HTMLElement {
      constructor() {
        super();
        this.downloadTemplatePatternUrl = this.dataset.productDownloadTemplateUrl;
        this.templateFileExtension = this.dataset.productDownloadTemplateFileExtension;
        this.currentVariant = {
          sku: this.dataset.productDefaultVariantSku
        };
        
        this.onInit();
        this.checkTemplateExists();
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            this.downloadButton.disabled = true;
            if (event.data.variant && event.data.variant != this.currentVariant) {
              this.currentVariant = event.data.variant;
              this.checkTemplateExists();
            }
          }
        );
      }

      disconnectedCallback() {
        if(this.variantChangeUnsubscriber) {
           this.variantChangeUnsubscriber();
        }
      }

      onInit() {
        this.downloadButton = document.querySelector("#download_template_button");

        this.downloadButton.disabled = true;

        this.downloadButton.addEventListener("click", () => {
          const templateName = this.currentVariant.sku.split('-')[0] + '.' + this.templateFileExtension;
          this.downloadURI(templateName);
        });
      }

      downloadURI(name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = this.templateUrl;
        link.click();
        link.remove();
      }

      checkTemplateExists() {
        const templateSku = this.currentVariant.sku.split('-')[0];
        this.templateUrl = this.downloadTemplatePatternUrl.replace(
          "current_sku",
          templateSku
        );
        fetch(this.templateUrl).then((response) => {
          if (response.ok) {
            this.downloadButton.disabled = false;
          }
          response.blob().then((blob) => {
            this.templateUrl = window.URL.createObjectURL(blob);
          });
        });
      }
    }
  );
}
